import { render, staticRenderFns } from "./Wishlist_Comment.vue?vue&type=template&id=6d5cd8ce"
import script from "./Wishlist_Comment.vue?vue&type=script&lang=js"
export * from "./Wishlist_Comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports